var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "silhouette-assistant",
      class: _vm.className,
      attrs: { role: "presentation" },
    },
    [
      !_vm.bubbleOnly
        ? _c("div", { staticClass: "character" }, [
            _c("img", {
              attrs: { src: _vm.imageSrc, alt: "", "aria-hidden": "true" },
            }),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "bubble-wrapper",
          class: _vm.bubbleClassName,
          attrs: { role: "presentation" },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }